import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import getMenuData from 'services/menu'
import {
  canManageBilling,
  canManageDashboard,
  canManageGift,
  canManageInbox,
  canManagePhoneAssistant,
  canManagePosts,
  canManageReports,
  canManageSales,
  canManageAllowance,
  selectIsAdmin,
  selectIsMainBusiness,
} from '../user/selectors'
import actions from './actions'

export function* GET_DATA() {
  let menuData = yield call(getMenuData)
  const allowDashboard = yield select(canManageDashboard)
  if (!allowDashboard) {
    menuData = menuData.filter(o => o.key !== 'dashboard')
  }
  const allowPosts = yield select(canManagePosts)
  if (!allowPosts) {
    menuData = menuData.filter(o => o.key !== 'posts')
  }
  const allowInbox = yield select(canManageInbox)
  if (!allowInbox) {
    menuData = menuData.filter(o => o.key !== 'inbox')
  } else {
    const inboxCount = yield select(state => state.menu.inboxCount)
    menuData = menuData.map(o => {
      if (o.key === 'inbox') {
        return {
          ...o,
          count: inboxCount > 0 ? inboxCount : null,
        }
      }
      return o
    })
  }
  const allowReports = yield select(canManageReports)
  const allowManageGift = yield select(canManageGift)
  const allowManageAllowance = yield select(canManageAllowance)
  const allowSales = yield select(canManageSales)
  if (!allowReports) {
    menuData = menuData.filter(o => o.key !== 'reports')
  } else {
    const reportsIndex = menuData.findIndex(o => o.key === 'reports')
    if (reportsIndex !== -1) {
      let reports = menuData[reportsIndex].children
      if (!allowInbox) {
        reports = reports.filter(o => o.key !== 'missed-calls')
      }
      if (!allowManageGift) {
        reports = reports.filter(o => !['gift-issued', 'gift-redeemed'].includes(o.key))
      }
      if (!allowManageAllowance) {
        reports = reports.filter(o => !['allowance-issued', 'allowance-redeemed'].includes(o.key))
      }
      if (!allowSales) {
        reports = reports.filter(o => o.key !== 'sales')
      }
      menuData[reportsIndex].children = reports
    }
  }
  const isAdmin = yield select(selectIsAdmin)
  const isMainBusiness = yield select(selectIsMainBusiness)
  if (!isAdmin) {
    menuData = menuData.filter(o => o.key !== 'settings')
  } else {
    const settingsIndex = menuData.findIndex(o => o.key === 'settings')
    if (settingsIndex !== -1) {
      let settings = menuData[settingsIndex].children
      if (isAdmin && !isMainBusiness) {
        settings = settings.filter(o => o.key !== 'brand')
        settings = settings.filter(o => o.key !== 'reward-program')
        settings = settings.filter(o => o.key !== 'custom-rewards')
        settings = settings.filter(o => o.key !== 'card-design')
        settings = settings.filter(o => o.key !== 'gift-card-design')
        settings = settings.filter(o => o.key !== 'allowance-card-design')
        settings = settings.filter(o => o.key !== 'website-widget')
        settings = settings.filter(o => o.key !== 'survey')
        settings = settings.filter(o => o.key !== 'customer-feedback')
      }
      if (!allowManageGift) {
        settings = settings.filter(o => o.key !== 'gift-card-design')
      }
      if (!allowManageAllowance) {
        settings = settings.filter(o => o.key !== 'allowance-card-design')
      }
      menuData[settingsIndex].children = settings
    }
  }
  const allowPhoneAssistant = yield select(canManagePhoneAssistant)
  if (!allowPhoneAssistant) {
    const settingsIndex = menuData.findIndex(o => o.key === 'settings')
    if (settingsIndex !== -1) {
      let settings = menuData[settingsIndex].children
      settings = settings.filter(o => o.key !== 'smart-inbox-setup')
      menuData[settingsIndex].children = settings
    }
  }
  const allowBilling = yield select(canManageBilling)
  if (!allowBilling) {
    menuData = menuData.filter(o => o.key !== 'billing')
  }
  yield put({
    type: actions.SET_STATE,
    payload: {
      menuData,
    },
  })
}

export function* UPDATE_INBOX_COUNT({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      inboxCount: payload.inboxCount,
    },
  })
  yield call(GET_DATA)
}

export default function* rootSaga() {
  yield all([
    GET_DATA(), // run once on app load to fetch menu data
    takeLatest(actions.REFRESH_MENU, GET_DATA),
    takeLatest(actions.UPDATE_INBOX_COUNT, UPDATE_INBOX_COUNT),
  ])
}
